export const TEST_ID = 'updateApplicationForm';
